<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        {{modalTitle}}
      </p>
      <button @click="closeModal" type="button" class="close-icon">
        <i class="mdi mdi-close"></i>
      </button>
    </header>
    <section class="modal-card-body padding-bottom82">

      <p>{{confirmationText}}</p>

    </section>
    <footer class="modal-card-foot">
      <button
          class="button is-primary btn-site-properties bg-white color-black"
          @click="confirm"
      >
        {{confirmationButtonText}}
      </button>

      <button
          class="button is-primary is-rounded btn-site-properties"
          @click="cancel"
      >
        {{cancelButtonText}}
      </button>
    </footer>
  </div>
</template>
<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({ components: {}})

export default class ConfirmationDialogue extends Vue {
  @Prop()
  public modalTitle!: string;
  @Prop()
  public confirmationText!: string;
  @Prop({
    default() {
      return 'Confirm';
    },
  })
  public confirmationButtonText!: string;
  @Prop({
    default() {
      return 'Cancel';
    },
  })
  public cancelButtonText!: string;
  public confirm() {
    this.$emit('confirm');
    this.$emit('close');
  }
  public cancel() {
    this.$emit('cancel');
    this.$emit('close');
  }
  public closeModal() {
    this.$emit('cancel');
    this.$emit('close');
  }
}
</script>
<style module>

</style>
